import BaseController from './basePlayerController';

export default class ControllerBetSelect extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eButtonsTypes = {
      EBT_SHOW_BETS: 'show_bets_button',
      EBT_HIDE_BETS: 'hide_bets_button',
    };
    this._eEventTypes =  {
      SHOW_BETS_CLICK: this.getEventName(this._eButtonsTypes.EBT_SHOW_BETS),
      HIDE_BETS_CLICK: this.getEventName(this._eButtonsTypes.EBT_HIDE_BETS),
    };
    this._eButtonsActions = {
      [this._eButtonsTypes.EBT_SHOW_BETS]: this._showCloseButton.bind(this),
      [this._eButtonsTypes.EBT_HIDE_BETS]: this._showOpenButton.bind(this),
    };
    this._eElementsTypes = {
      EET_SHOW_BETS_BUTTON: this._eButtonsTypes.EBT_SHOW_BETS,
      EET_HIDE_BETS_BUTTON: this._eButtonsTypes.EBT_HIDE_BETS,
    };

    this.init(container);
    this._showOpenButton();
  }

  reset() {
    this._showOpenButton();
  }

  _showOpenButton() {
    this.interactiveElements[this._eElementsTypes.EET_SHOW_BETS_BUTTON].classList.remove('hidden');
    this.interactiveElements[this._eElementsTypes.EET_HIDE_BETS_BUTTON].classList.add('hidden');
  }

  _showCloseButton() {
    this.interactiveElements[this._eElementsTypes.EET_SHOW_BETS_BUTTON].classList.add('hidden');
    this.interactiveElements[this._eElementsTypes.EET_HIDE_BETS_BUTTON].classList.remove('hidden');
  }

  _getMarkup() {
    return `<button id=${this.interactiveElementsIds[this._eElementsTypes.EET_SHOW_BETS_BUTTON]} data-color="primary"}>
          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M67.8333 46.3834V59.9501C67.8333 71.3901 57.1633 80.6668 44 80.6668C30.8367 80.6668 20.1667 71.3901 20.1667 59.9501V46.3834C20.1667 57.8234 30.8367 66.0001 44 66.0001C57.1633 66.0001 67.8333 57.8234 67.8333 46.3834Z" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M67.8333 28.05C67.8333 31.3867 66.9166 34.4667 65.3033 37.1067C61.38 43.56 53.3133 47.6667 44 47.6667C34.6867 47.6667 26.62 43.56 22.6967 37.1067C21.0833 34.4667 20.1667 31.3867 20.1667 28.05C20.1667 22.33 22.8433 17.16 27.1333 13.42C31.46 9.64337 37.4 7.33337 44 7.33337C50.6 7.33337 56.54 9.64338 60.8667 13.3834C65.1567 17.16 67.8333 22.33 67.8333 28.05Z" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M67.8333 28.05V46.3834C67.8333 57.8234 57.1633 66 44 66C30.8367 66 20.1667 57.8234 20.1667 46.3834V28.05C20.1667 16.61 30.8367 7.33337 44 7.33337C50.6 7.33337 56.54 9.64338 60.8667 13.3834C65.1567 17.16 67.8333 22.33 67.8333 28.05Z" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          </button>
          <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_HIDE_BETS_BUTTON]} data-color="primary"}>
            <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M67.8333 46.3834V59.9501C67.8333 71.3901 57.1633 80.6668 44 80.6668C30.8367 80.6668 20.1667 71.3901 20.1667 59.9501V46.3834C20.1667 57.8234 30.8367 66.0001 44 66.0001C57.1633 66.0001 67.8333 57.8234 67.8333 46.3834Z" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M67.8333 28.05C67.8333 31.3867 66.9166 34.4667 65.3033 37.1067C61.38 43.56 53.3133 47.6667 44 47.6667C34.6867 47.6667 26.62 43.56 22.6967 37.1067C21.0833 34.4667 20.1667 31.3867 20.1667 28.05C20.1667 22.33 22.8433 17.16 27.1333 13.42C31.46 9.64337 37.4 7.33337 44 7.33337C50.6 7.33337 56.54 9.64338 60.8667 13.3834C65.1567 17.16 67.8333 22.33 67.8333 28.05Z" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M67.8333 28.05V46.3834C67.8333 57.8234 57.1633 66 44 66C30.8367 66 20.1667 57.8234 20.1667 46.3834V28.05C20.1667 16.61 30.8367 7.33337 44 7.33337C50.6 7.33337 56.54 9.64338 60.8667 13.3834C65.1567 17.16 67.8333 22.33 67.8333 28.05Z" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>`
  }
}
